import { IOpModifier, IOpOperacja } from "./IOp"


export class op_api {
    public static save_changed:string = "/api/operacje/save_changed"
    public static del_operacje_for_prj:string = "/api/operacje/del_operace_for_prj"
    public static del_operacje_for_tree:string = "/api/operacje/del_operacje_for_tree"
    public static del_operacje_for_lbl:string = "/api/operacje/del_operacje_for_lbl"
    public static get_operacje:string = "/api/operacje/get_operacje"
    public static trees_to_operacje:string = "/api/operacje/trees_to_operacje"
    public static find_by_id:string = "/api/operacje/find_by_id"
}

export interface IOpServer {
    del_operacje_for_prj(prj_id:any, physical: number):any
    del_operacje_for_tree(tree_id:any, physical: number):any
    del_operacje_for_lbl(lbl_id:any, physical: number):any
    
    get_operacje(tree_id:any):any
    save_changed(modified: IOpModifier[], operacje:IOpOperacja[]): Promise<IOpModifier[]> 
    trees_to_operacje():void
    find_by_id(_id:any):any
}